import React from 'react';
import { X, QrCode, Camera } from 'lucide-react';
import toast from 'react-hot-toast';

const QRScannerModal = ({ setShowScanner }) => (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
    <div className="bg-white rounded-xl max-w-md w-full max-h-[90vh] overflow-y-auto">
      <div className="p-6">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-xl sm:text-2xl font-bold text-gray-900">Scan QR Code</h2>
          <button onClick={() => setShowScanner(false)}
            className="text-gray-400 hover:text-gray-600 p-2 rounded-full hover:bg-gray-100 transition-colors min-w-[44px] min-h-[44px] flex items-center justify-center">
            <X size={24} />
          </button>
        </div>
        <div className="mb-6 p-4 bg-blue-50 rounded-lg border border-blue-200">
          <div className="flex items-start space-x-3">
            <QrCode size={24} className="text-blue-600 flex-shrink-0 mt-1" />
            <div>
              <h3 className="text-sm font-medium text-blue-900 mb-1">How to scan</h3>
              <p className="text-sm text-blue-700">Point your camera at the QR code on the asset label. Make sure the code is clearly visible and well-lit.</p>
            </div>
          </div>
        </div>
        <div className="mb-6"><div id="qr-scanner" className="w-full"></div></div>
        <div className="space-y-3">
          <button
            onClick={() => {
              const fileInput = document.createElement("input");
              fileInput.type = "file"; fileInput.accept = "image/*"; fileInput.capture = "environment";
              fileInput.onchange = () => toast.info("Image scanning feature coming soon");
              fileInput.click();
            }}
            className="w-full bg-gray-100 hover:bg-gray-200 text-gray-700 px-6 py-4 rounded-lg transition-colors flex items-center justify-center gap-3 min-h-[52px] font-medium"
          >
            <Camera size={20} /><span>Scan an Image File</span>
          </button>
          <button onClick={() => setShowScanner(false)}
            className="w-full bg-red-100 hover:bg-red-200 text-red-700 px-6 py-4 rounded-lg transition-colors flex items-center justify-center gap-3 min-h-[52px] font-medium">
            <X size={20} /><span>Cancel Scanning</span>
          </button>
        </div>
      </div>
    </div>
  </div>
);

export default QRScannerModal;
